import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../Helper/ToastMessage";


// Get Table Data
export const STPEquipmentWorkTableDataAPI = createAsyncThunk("STPEquipmentWorkTableData", async ({ data }) => {
    const {
        M_STP_EquipmentWorkID,
        M_STP_EquipmentMasterID,
        M_STP_WorkPeriodID,
        M_WardID,
        M_UserID,
        token,
        From,
        To,
        handleSTPEquipmentWorkExport
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/Master/Get_WEB_M_STP_EquipmentWork_Select?M_STP_EquipmentWorkID=${M_STP_EquipmentWorkID ? M_STP_EquipmentWorkID : '0'}&M_STP_EquipmentMasterID=${M_STP_EquipmentMasterID ? M_STP_EquipmentMasterID : '0'}&M_STP_WorkPeriodID=${M_STP_WorkPeriodID ? M_STP_WorkPeriodID : '0'}&M_WardID=${M_WardID ? M_WardID : '0'}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            // console.log(result.data1, result.data) 
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleSTPEquipmentWorkExport && handleSTPEquipmentWorkExport()
                return result.data

            } else {
                return result
            }
        })
})

const STPEquipmentWorkTableDataSlice = createSlice({
    name: "STPEquipmentWorkTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPEquipmentWorkTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(STPEquipmentWorkTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(STPEquipmentWorkTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const STPEquipmentWorkTableDataReducer = STPEquipmentWorkTableDataSlice.reducer


export const STPEquipmentWorkTableExportDataAPI = createAsyncThunk("STPEquipmentWorkTableExportData", async ({ data }) => {
    const {
        M_STP_EquipmentWorkID,
        M_STP_EquipmentMasterID,
        M_STP_WorkPeriodID,
        M_WardID,
        M_UserID,
        token,
        From,
        To,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/Master/Get_WEB_M_STP_EquipmentWork_Select?M_STP_EquipmentWorkID=${M_STP_EquipmentWorkID ? M_STP_EquipmentWorkID : '0'}&M_STP_EquipmentMasterID=${M_STP_EquipmentMasterID ? M_STP_EquipmentMasterID : '0'}&M_STP_WorkPeriodID=${M_STP_WorkPeriodID ? M_STP_WorkPeriodID : '0'}&M_WardID=${M_WardID ? M_WardID : '0'}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            // console.log(result.data1, result.data) 
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data

            } else {
                return result
            }
        })
})

const STPEquipmentWorkTableExportDataSlice = createSlice({
    name: "STPEquipmentWorkTableExportData",
    initialState: {
        isExportLoading: false,
        ExportTableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPEquipmentWorkTableExportDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(STPEquipmentWorkTableExportDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExportTableData = action.payload;
        });
        builder.addCase(STPEquipmentWorkTableExportDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExportTableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const STPEquipmentWorkTableExportDataReducer = STPEquipmentWorkTableExportDataSlice.reducer



export const STPEquipmentWorkPostDataAPI = createAsyncThunk("STPEquipmentWorkPostData", async ({ data }) => {
    const {
        M_STP_EquipmentWorkID,
        M_STP_EquipmentMasterID,
        M_STP_WorkPeriodID,
        EquipmentName,
        M_UserID,
        token,
        Flag,
        handleIsPost,
        handleClearField,
        handleOnCloseClick,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("M_STP_EquipmentWorkID", M_STP_EquipmentWorkID);
    formdata.append("M_STP_EquipmentMasterID", M_STP_EquipmentMasterID);
    formdata.append("M_STP_WorkPeriodID", M_STP_WorkPeriodID);
    formdata.append("EquipmentName", EquipmentName);
    formdata.append("M_UserID", M_UserID);
    formdata.append("Flag", Flag);

    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/Master/Post_WEB_M_STP_EquipmentWork_InsertUpdate`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                // handleClearField()
                handleOnCloseClick()
                toastSuccesss(result.message)
                return result.data
            } else {
                toastErrorr(result.message)
            }
            return result
        })
})

const STPEquipmentWorkPostDataSlice = createSlice({
    name: "STPEquipmentWorkPostData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPEquipmentWorkPostDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(STPEquipmentWorkPostDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(STPEquipmentWorkPostDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const STPEquipmentWorkPostDataReducer = STPEquipmentWorkPostDataSlice.reducer

// -----------------Delete API ---------------

export const STPEquipmentWorkDeleteAPI = createAsyncThunk("STPEquipmentWorkDelete", async ({ data }) => {
    const {
        M_STP_EquipmentWorkID,
        M_UserID,
        token,
        handleIsPost
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);


    var formdata = new FormData();
    formdata.append("M_STP_EquipmentWorkID", M_STP_EquipmentWorkID);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/Master/WEB_M_STP_EquipmentWork_Delete`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)

            }
            return result

        })
})

const STPEquipmentWorkDeleteSlice = createSlice({
    name: "STPEquipmentWorkDelete",
    initialState: {
        isDeleteLoading: false,
        SectorData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPEquipmentWorkDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(STPEquipmentWorkDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.SectorData = action.payload;

        });
        builder.addCase(STPEquipmentWorkDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.SectorData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const STPEquipmentWorkDeleteReducer = STPEquipmentWorkDeleteSlice.reducer